export default __webpack_public_path__ + "static/mark-506ebdbfda4274ec1178bcc84f91bbb3.jpg";